<template>
  <div :id="page_slug">

    <div class="crumbs-bar">
      <el-row>
        <el-col :span="12">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'DashboardPage' }">Dashboard</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ name: 'CorporationList' }">Corporations</el-breadcrumb-item>
            <el-breadcrumb-item>Edit</el-breadcrumb-item>
          </el-breadcrumb>        
        </el-col>      
      </el-row>
    </div>

    <el-form 
      ref="corporation" 
      :model="corporation"
      :rules="rules.corporation"
      :label-position="label_position">

      <el-form-item label="Name:" prop="name">
        <el-input v-model="corporation.name"></el-input>
      </el-form-item>

      <el-form-item label="Corporate UID:" prop="corporateUID">
        <el-input disabled v-model="corporation.corporateUID"></el-input>
      </el-form-item>

      <el-form-item label="Portal IP:" prop="portal_ip">
        <el-input v-model="corporation.portal_ip"></el-input>
      </el-form-item>

      <el-form-item label="Portal URL:" prop="portal_url">
        <el-input v-model="corporation.portal_url"></el-input>
      </el-form-item>

      <el-form-item label="Backend Portal URL:" prop="backend_portal_url">
        <el-input v-model="corporation.backend_portal_url"></el-input>
      </el-form-item>

      <el-form-item label="Notes:" prop="notes">
        <el-input type="textarea" :rows="3" :autosize="false" v-model="corporation.notes"></el-input>
      </el-form-item>

      <el-form-item label="Headquarters Fee:" prop="hq_fee">
        <el-input-number :min="0" v-model="corporation.hq_fee"></el-input-number>
      </el-form-item>

      <el-form-item label="Site Fee:" prop="site_fee">
        <el-input-number :min="0" v-model="corporation.site_fee"></el-input-number>
      </el-form-item>

      <el-form-item label="Licence Count:" prop="licence_count">
        <el-input-number :min="0" v-model="corporation.licence_count"></el-input-number>
      </el-form-item>

      <el-form-item label="Account Manager:" prop="account_manager_id">
        <el-select 
          v-model="corporation.account_manager_id" 
          placeholder="Select Here">
          <el-option
          v-for="item in users"
          :key="item.id"
          :label="item.firstName + ' ' + item.lastName"
          :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>   

      <el-form-item>
        <el-button type="primary" @click="updateCorporation('corporation')">Update</el-button>
      </el-form-item>
    </el-form>

    <pre>{{$data}}</pre>
  </div>
</template>

<style>
</style>

<script>
  import Config from '@/store/Config.js';
  import Utils from '@/components/utils/Utils.js';
  import Auth from '@/components/auth/AuthCheck.js';

  export default {
    data: function() {
      return { 
        config: Config.config,
        
        page_alias: 'Edit Corporation',
        page_slug: 'edit-corporation',
        label_position: 'top',

        corporation: {
          name: '',
          corporateUID: '',
          portal_ip: '',
          portal_url: '',
          backend_portal_url: '',
          notes: '',
          hq_fee: '',
          site_fee: '',
          licence_count: '',
          account_manager_id: '',
          updated_user_id: '',
        },

        users: [],

        rules: {
          corporation: {
            name: [
              {required: true, message: 'Please Enter Name', trigger: 'blur'}
            ],
            portal_ip: [
              {required: true, message: 'Please Enter Portal IP', trigger: 'blur'}
            ],
            portal_url: [
              {required: true, message: 'Please Enter Portal URL', trigger: 'blur'},
              {type: 'url', message: 'Please Enter Valid URL', trigger: 'blur'}
            ],
            backend_portal_url: [
              {required: true, message: 'Please Enter Backend Portal URL', trigger: 'blur'},
              {type: 'url', message: 'Please Enter Valid URL', trigger: 'blur'}
            ],
            account_manager_id: [
              {required: true, message: 'Please Choose Account Manager ID', trigger: 'blur'}
            ],
          }
        }
      };
    },

    mounted: function() {
      const me = this;
      me.getCorporation();
      me.getUsers();
    },

    methods: {
      getCorporation: function() {
        console.log('Get Corporation Function');
        const me = this;
        me.$http.get(me.config.api + 'corporation/{id}', {params: {id : me.$route.params.id}}).then(
          response => {
          console.log('Success Getting Data')  
          console.log(response.status);
          console.log(response.statusText);
          me.corporation = response.body.data;
        }, response => {
          console.log('Error Getting Data');
          console.log(response.status);
          console.log(response.statusText);
        });
      },

      updateCorporation: function(formName) {
        console.log('Update Corporation Function');
        const me = this;
        me.$refs[formName].validate((valid) => {
          if (valid) {
            var jwt = Utils.decodejwt();
            me.corporation.updated_user_id = jwt.sub;
            me.$http.put(me.config.api + 'corporation/{id}', me.corporation, {params: {id : me.$route.params.id}}).then(
              response => {
              console.log('Success Putting Data')  
              console.log(response.status);
              console.log(response.statusText);

              me.getCorporation();

              me.$notify({
                title: 'Success',
                message: 'The Corporation Was Updated',
                type: 'success'
              });
            }, response => {
              console.log('Error Putting Data');
              console.log(response.status);
              console.log(response.statusText);
              console.log(response.bodyText);
          });
          } else {
            console.log('Fields Not Valid');
            return false;
          }
        });
      },

      getUsers: function() {
        console.log('Get Users Function');

        const me = this;
        me.loading = true;

        me.$http.get(me.config.api + 'user', {params: {backend_call: 1}}).then(
          response => {
            console.log('Success Getting Data')  
            console.log(response.status);
            console.log(response.statusText);

            me.users = response.body.data;
            me.loading = false;
          }, response => {
            console.log('Error Getting Data');
            console.log(response.status);
            console.log(response.statusText);

            me.$notify({
              title: 'Error',
              message: response.statusText,
              stype: 'error'
            });

            me.loading = false;
          }
        );
      }
    }
  }
</script>





// WEBPACK FOOTER //
// src/pages/corporations/CorporationEdit.vue